<template>
    <div class="prize">
        <div class="close cursor" @click="closePriseModel"></div>
        <div class="cnt w100 h100 d-flex  align-items-center justify-content-center flex-direction-column">
            <div v-if=" Object.keys(pList).length > 0">
                <div v-for="(value, key) in pList" :key="key" class="item mb-8 cursor"
                    @click="showDetailModel(value, key)">
                    {{ value }}</div>
            </div>

            <div v-else class="txt-empty txt-style">상품이 없습니다.</div>
      
        </div>

        <!-- 奖品详情弹出框 -->
        <div class="model  position-absolute" v-if="detailModel">
            <div class="detail-cnt txt-style">
                <div class="close cursor" @click="closeDetailModel"></div>
                <div class="detail h100 d-flex align-items-center justify-content-center flex-direction-column">
                    <div class="c-text">
                        <img class="img-size" :src="require(`../../../assets/img/m4/lottery/gift${detail}.png`)" alt=""
                            srcset="" width="100%">
                        <div class="code">{{ code }}</div>
                    </div>
                    <div class="back cursor" @click="closeDetailModel"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["priseList"],

    data() {
        return {
            detailModel: false, // 奖品详情弹出框
            pList: this.priseList,
            // priseList: JSON.parse(localStorage.getItem("rewards")),
            title: '',
            detail: '',
            code: ''
        }
    },
    created() {
    },
    methods: {
        closePriseModel() {
            this.$emit('prizeModelClose', false, 2)
        },
        // 显示详情
        showDetailModel(value, key) {
            this.detailModel = true
            this.code = value
            this.detail = key
        },
        // 关闭奖品详情
        closeDetailModel() {
            this.detailModel = false
        },
        // 返回页
        // backModel() {}
    }
}
</script>
<style lang="scss" scoped>
.prize {
    background: url("../../../assets/img/common/model-bg.png") no-repeat top;
    background-size: 100% 100%;
    width: 716px;
    height: 339px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .close {
        background: url("../../../assets/img/common/close.png") no-repeat top;
        background-size: 100% 100%;
        width: 56px;
        height: 49px;
        position: absolute;
        right: 0;
        top: -49px;

    }

    .cnt {
        .item {
            width: 516px;
            height: 47px;
            background-color: #000000;
            font-family: ONEMobileTitleRegular;
            font-size: 18px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 47px;
            text-align: center;
            letter-spacing: 0px;
            color: #ffffff;
        }
    }

    .txt-style {
        font-family: ONEMobileTitleRegular;
        font-weight: normal;
        font-stretch: normal;
        line-height: 30px;
        letter-spacing: 0px;
        color: #000000;
        font-weight: bold;
        font-size: 24px;

    }

    .detail-cnt {
        background: url("../../../assets/img/common/model-bg.png") no-repeat top;
        background-size: 100% 100%;
        width: 716px;
        height: 470px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

       
        .back {
            background: url("../../../assets/img/m4/lottery/back.png") no-repeat top;
            background-size: 100% 100%;
            width: 244px;
            height: 60px;
            margin-top: 24px;
        }

        .title {
            font-size: 30px;
        }

    
       
        .c-text {
            width: 460px;
            max-width: 460px;
            height: 218px;
            display: flex;
            align-items: center;
            flex-direction: column;
            position: relative;

            img {
                display: block;
                width: 217px;
                height: 218px;
            }

            .code {
                width: 100%;
                height: 50px;
                line-height: 50px;
                background-color: #d81028;
                position: absolute;
                bottom: 0;
                text-align: center;
                color: #fff;
                text-overflow: ellipsis;
                overflow: hidden;
                word-break: break-all;
                white-space: nowrap;
                padding: 0 6px;

            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/eventComponents/prize.vue